import { render, staticRenderFns } from "./MirrorsGroupsTab.vue?vue&type=template&id=131a6c04&scoped=true&"
import script from "./MirrorsGroupsTab.vue?vue&type=script&lang=js&"
export * from "./MirrorsGroupsTab.vue?vue&type=script&lang=js&"
import style0 from "./MirrorsGroupsTab.vue?vue&type=style&index=0&id=131a6c04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131a6c04",
  null
  
)

export default component.exports